import React, { useState } from 'react';
import { MessageCircle, X } from 'lucide-react';
import ChatSupportModal from '../ChatSupportModal/ChatSupportModal';
import './ChatSupportButton.scss';

const ChatSupportButton = ({ userId, userType }) => {
  const [isOpen, setIsOpen] = useState(false);

  return (
    <>
      {/* Botão flutuante */}
      <button
        className={`chat-support-btn ${isOpen ? 'chat-support-btn--active' : ''}`}
        onClick={() => setIsOpen(!isOpen)}
        aria-label="Abrir suporte"
      >
        {isOpen ? (
          <X size={24} />
        ) : (
          <MessageCircle size={24} />
        )}
      </button>

      {/* Modal do chat */}
      {isOpen && (
        <ChatSupportModal
          userId={userId}
          userType={userType}
          onClose={() => setIsOpen(false)}
        />
      )}
    </>
  );
};

export default ChatSupportButton;